import React from 'react';
import AllArticles from './AllArticles';
import Styles from './css/AllBlogsPage.module.css';
import StaffPicks from './StaffPicks';

const AllBlogsPage = ({ blogData, staffPicksData, isStaffPicks }) => {
  return (
    <section className={Styles.container}>
      <div className={Styles.container_allArticles}>
        <AllArticles blogData={blogData} />
      </div>
      {isStaffPicks && (
        <div className={Styles.container_staffPicks}>
          <StaffPicks textTitle={'Lo más leído'} blogData={staffPicksData} />
        </div>
      )}
    </section>
  );
};

export default AllBlogsPage;
